var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrowQuickshipPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FLECHA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 4",
    d: "M1.12627 14.7071C0.735743 14.3166 0.735743 13.6834 1.12627 13.2929L7.49023 6.92893C7.88075 6.53841 8.51392 6.53841 8.90444 6.92893C9.29497 7.31946 9.29497 7.95262 8.90444 8.34315L3.24759 14L8.90444 19.6569C9.29497 20.0474 9.29497 20.6805 8.90444 21.0711C8.51392 21.4616 7.88075 21.4616 7.49023 21.0711L1.12627 14.7071ZM29.3334 15L1.83337 15L1.83337 13L29.3334 13L29.3334 15Z",
    fill: "#6C757D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowQuickshipPage);
export default __webpack_public_path__ + "static/media/left-arrow-quickship-page.325a26b78b451cdd32ebc71088c61717.svg";
export { ForwardRef as ReactComponent };